var React = require('react');

function HourglassInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M738 0H0L63.7328 94.7478C23.76 136.858 0 189.843 0 247.455C0 306.224 24.3191 360.366 64.9907 403.286L0 500L738 500L673.009 403.286C713.681 360.366 738 306.224 738 247.455C738 189.843 714.24 136.742 674.267 94.7478L738 0Z"}));
}

HourglassInline.defaultProps = {"width":"738","height":"500","viewBox":"0 0 738 500","fill":"none"};

module.exports = HourglassInline;

HourglassInline.default = HourglassInline;
